module.exports = __webpack_public_path__ + "media/stylesheets/images/media/userway_function_icons/icn-feature-29-1be04176fef9734380befbd4a52f308e.svg";